module.exports = __webpack_public_path__ + "static/media/add.bb36a24b.svg";